export enum FEATURE_FLAGS {
  ENABLE_VOICE_OF_CUSTOMER_INTERRUPTION_POPUP = `enable-voice-of-customer-interruption-popup`,
  ENABLE_ANONYMOUS_FLOW = `enable-anonymous-flow`,
  ENABLE_ADOBE_TARGET_PERSONALIZATION = `enable-adobe-target-personalization`,
}
